exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "table[data-v-04e48dd4]{border-collapse:collapse}table[data-v-04e48dd4],td[data-v-04e48dd4],th[data-v-04e48dd4]{border:1px solid #000}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/receive_products.vue"],"names":[],"mappings":"AACA,uBACE,wBAA0B,CAC3B,AACD,+DACE,qBAAwB,CACzB","file":"receive_products.vue","sourcesContent":["\ntable[data-v-04e48dd4] {\n  border-collapse: collapse;\n}\ntable[data-v-04e48dd4], th[data-v-04e48dd4], td[data-v-04e48dd4] {\n  border: 1px solid black;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04e48dd4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pos/receive_products.vue
// module id = 1216
// module chunks = 0